// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-preview-modal {
  width: fit-content;
}
.map-preview-modal .ant-modal-content {
  padding: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/resource/nodepkg/children-section/component/PreviewModal.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AAFA;EAIQ,qBAAA;AACR","sourcesContent":[".map-preview-modal {\n    width: fit-content;\n\n    .ant-modal-content {\n        padding: 0 !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
